import { render, staticRenderFns } from "./refundDetail.vue?vue&type=template&id=3120361a&scoped=true&"
import script from "./refundDetail.vue?vue&type=script&lang=js&"
export * from "./refundDetail.vue?vue&type=script&lang=js&"
import style0 from "./refundDetail.vue?vue&type=style&index=0&id=3120361a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120361a",
  null
  
)

export default component.exports